
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsDebitCardDialog extends Serenity.EntityDialog<PsDebitCardRow, any> {
        protected getFormKey() { return PsDebitCardForm.formKey; }
        protected getIdProperty() { return PsDebitCardRow.idProperty; }
        protected getLocalTextPrefix() { return PsDebitCardRow.localTextPrefix; }
        protected getNameProperty() { return PsDebitCardRow.nameProperty; }
        protected getService() { return PsDebitCardService.baseUrl; }
        protected getDeletePermission() { return PsDebitCardRow.deletePermission; }
        protected getInsertPermission() { return PsDebitCardRow.insertPermission; }
        protected getUpdatePermission() { return PsDebitCardRow.updatePermission; }

        protected form = new PsDebitCardForm(this.idPrefix); 
        constructor(container: JQuery) {
            super(container);
            
            
            

            
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            

        }

    }
}